<div class="document-viewer-dialog">
    <!-- Dialog Header -->
    <div mat-dialog-title class="dialog-header">
        <div class="header-content">
            <!--<mat-icon class="file-icon">description</mat-icon>-->
            <h2>{{ data.fileName || 'Document Viewer' }}</h2>
        </div>
        <button mat-icon-button (click)="onClose()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Dialog Content -->
    <mat-dialog-content class="dialog-content">
        <!-- Loading Spinner Overlay -->
        <div *ngIf="isLoading" class="loading-container">
            <mat-spinner diameter="50"></mat-spinner>
            <p>Loading document...</p>
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="error-container">
            <mat-icon color="warn">error_outline</mat-icon>
            <p>{{ errorMessage }}</p>
        </div>

        <!-- PDF Viewer -->
        <iframe 
            *ngIf="isPdf && !errorMessage"
            [src]="safeUrl" 
            class="document-iframe"
            [class.loading]="isLoading"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            frameborder="0">
        </iframe>

        <!-- Image Viewer -->
        <div *ngIf="isImage && !errorMessage" class="image-container" [class.loading]="isLoading">
            <img 
                [src]="safeUrl" 
                [alt]="data.fileName"
                (load)="onIframeLoad()"
                (error)="onIframeError()"
                class="document-image">
        </div>

        <!-- Office Document Viewer -->
        <iframe 
            *ngIf="isOfficeDoc && !errorMessage"
            [src]="safeUrl" 
            class="document-iframe"
            [class.loading]="isLoading"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            frameborder="0">
        </iframe>

        <!-- Text File Viewer -->
        <iframe 
            *ngIf="isText && !errorMessage"
            [src]="safeUrl" 
            class="document-iframe text-iframe"
            [class.loading]="isLoading"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            frameborder="0">
        </iframe>

        <!-- Generic Viewer (Google Docs Fallback) -->
        <iframe 
            *ngIf="!isPdf && !isImage && !isOfficeDoc && !isText && !errorMessage"
            [src]="safeUrl" 
            class="document-iframe"
            [class.loading]="isLoading"
            (load)="onIframeLoad()"
            (error)="onIframeError()"
            frameborder="0">
        </iframe>
    </mat-dialog-content>

    <!-- Dialog Actions -->
    <mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="onClose()" class="close-action-button">
            <mat-icon>close</mat-icon>
            Close
        </button>
    </mat-dialog-actions>
</div>
